import {
  FETCH_ACCOUNT_TYPE_MAPPING_REQUEST,
  FETCH_ACCOUNT_TYPE_MAPPING_SUCCESS,
  FETCH_ACCOUNT_TYPE_MAPPING_FAILURE,
} from '../../../../Constants/actionTypes';

import { fetchAccountTypeMapping } from '../../../../Constants/apiService';

export const fetchAccountTypeMappingRequest = () => ({ type: FETCH_ACCOUNT_TYPE_MAPPING_REQUEST });
export const fetchAccountTypeMappingSuccess = (data) => ({
  type: FETCH_ACCOUNT_TYPE_MAPPING_SUCCESS,
  payload: data,
});
export const fetchAccountTypeMappingFailure = (error) => ({
  type: FETCH_ACCOUNT_TYPE_MAPPING_FAILURE,
  payload: error,
});

export const fetchAccountTypeMappingAct = () => {
  return async (dispatch) => {
    dispatch(fetchAccountTypeMappingRequest());

    try {
      const data = await fetchAccountTypeMapping();
      dispatch(fetchAccountTypeMappingSuccess(data));
      return data;
    } catch (error) {
      const errorMessage =
        error?.message === 'Failed to fetch' || error?.message?.includes('NetworkError')
          ? 'Server is currently down. Please try again later.'
          : error?.message || 'Something went wrong';

      dispatch(fetchAccountTypeMappingFailure(errorMessage));
      throw new Error(errorMessage);
    }
  };
};
